exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-timeline--dense .v-timeline-item[data-v-51e82ed2] {\n  padding-bottom: 8px;\n}\n", ""]);

// exports
